import Constants from "../Constants.js";
import ResourceTemporaryUser from "./ResourceTemporaryUser.js";
/**
 * This is meant to be a generic, reusable user action generator.
 * It needs the resourceId.
 * <code>
 * user : ( userId ) => {
 *   return new User( {
 *     userId,
 *     resourceId : this.id, // with is th device, system, project, script, etc id
 *     resourceApi : ( dispatch, getState, opts, resourceId ) => {
 *       // this return's a the api on which the user's calls exist
 *       return opts.api.resource( resourceId ) 
 *     }
 *   })
 * }
 */
class ResourceTemporaryUsers {
  constructor(opts) {
    this.opts = opts;
    const {
      resourceId,
      resourceApi
    } = opts;
    this.resourceApi = resourceApi;
    this.resourceId = resourceId;
  }
  createAction(method, status, func) {
    return (dispatch, getState, opts) => {
      dispatch({
        type: Constants.RESOURCE_TEMPORARY_USER_STATUS,
        resourceId: this.resourceId,
        status
      });
      const api = this.resourceApi(dispatch, getState, opts, this.resourceId);
      // override top level api with resource api
      return func(dispatch, getState, {
        ...opts,
        api
      }, this.resourceId).catch(error => {
        dispatch({
          type: Constants.RESOURCE_TEMPORARY_USER_STATUS,
          resourceId: this.resourceId,
          status: `${method}Error`,
          error
        });
        return Promise.reject(error);
      });
    };
  }
  getUsername(u) {
    return `${u.createdBy}::${u.id}`;
  }
  reqToUser(u) {
    return {
      ...u,
      username: this.getUsername(u)
    };
  }
  reqListToUsers(res) {
    return {
      ...res,
      items: res.items?.map(u => this.reqToUser(u))
    };
  }
  list(opts) {
    return this.createAction('load', 'loading', async (dispatch, getState, {
      api
    }, resourceId) => {
      const {
        requestId,
        ...reqOpts
      } = opts || {};
      const r = await api.temporaryUsers().list(reqOpts);
      const mod = this.reqListToUsers(r);
      dispatch({
        type: Constants.RESOURCE_TEMPORARY_USER_LIST,
        requestId,
        resourceId,
        ...mod
      });
      return mod;
    });
  }
  create(opts) {
    return this.createAction('addUser', 'adding user', async (dispatch, getState, {
      api
    }, resourceId) => {
      const user = this.reqToUser(await api.temporaryUsers().create(opts));
      dispatch({
        type: Constants.RESOURCE_TEMPORARY_USER_ADD,
        resourceId,
        user
      });
      return user;
    });
  }
  update(userId, body, opts) {
    const r = new ResourceTemporaryUser({
      ...this.opts,
      userId
    });
    return r.update(body, opts);
  }
  delete(userId, body, opts) {
    const r = new ResourceTemporaryUser({
      ...this.opts,
      userId
    });
    return r.delete(body, opts);
  }
  revoke(userId, body, opts) {
    const r = new ResourceTemporaryUser({
      ...this.opts,
      userId
    });
    return r.revoke(body, opts);
  }
  renew(userId, body, opts) {
    const r = new ResourceTemporaryUser({
      ...this.opts,
      userId
    });
    return r.renew(body, opts);
  }
  share(userId, body, opts) {
    const r = new ResourceTemporaryUser({
      ...this.opts,
      userId
    });
    return r.share(body, opts);
  }
  canCreate() {
    return async (dispatch, getState, opts) => {
      const api = this.resourceApi(dispatch, getState, opts, this.resourceId);
      const r = await api.temporaryUsers().create({}, {
        test: true
      });
      dispatch({
        type: Constants.ALLOWED_SET,
        resourceId: this.resourceId,
        action: 'createTemporaryUser',
        allowed: r.allowed === true
      });
      return r;
    };
  }
  canUpdate(body, opts) {
    const r = new ResourceTemporaryUser(this.opts);
    return r.canUpdate(body, opts);
  }
  canDelete(body, opts) {
    const r = new ResourceTemporaryUser(this.opts);
    return r.canDelete(body, opts);
  }
  canRevoke(body, opts) {
    const r = new ResourceTemporaryUser(this.opts);
    return r.canRevoke(body, opts);
  }
  canRenew(body, opts) {
    const r = new ResourceTemporaryUser(this.opts);
    return r.canRenew(body, opts);
  }
  canShare(body, opts) {
    const r = new ResourceTemporaryUser(this.opts);
    return r.canShare(body, opts);
  }
  canList() {
    return async (dispatch, getState, opts) => {
      const api = this.resourceApi(dispatch, getState, opts, this.resourceId);
      const r = await api.temporaryUsers().list({
        test: true
      });
      dispatch({
        type: Constants.ALLOWED_SET,
        resourceId: this.resourceId,
        action: 'listTemporaryUsers',
        allowed: r.allowed === true
      });
      return r;
    };
  }
}
export default ResourceTemporaryUsers;